// @ts-strict-ignore
import { SharedUserRightVO } from '@user/model/vo/shared-user-right.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('SharedObjectInfoVO')
export class SharedObjectInfoVO {
  @JsonProperty('objectId', 'Number')
  public objectId: number = undefined;

  @JsonProperty('userRights', '[SharedUserRightVO]')
  public userRights: SharedUserRightVO[] = undefined;
}

@JsonObject('SharedProjectInfoVO')
export class SharedProjectInfoVO extends SharedObjectInfoVO {
}

@JsonObject('SharedProjectGroupInfoVO')
export class SharedProjectGroupInfoVO extends SharedObjectInfoVO {
}
